import Matter from "matter-js";

export default function makeElementsFall(container, elements, direction, solids = []) {
    const { Engine, World, Bodies, Events, Runner } = Matter;

    // Créer un moteur physique
    const engine = Engine.create();
    const world = engine.world;

    // Récupérer la taille du conteneur
    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;

    // Ajouter des limites pour le conteneur (quatre côtés)
    const boundaries = [
        Bodies.rectangle(containerWidth / 2, -25, containerWidth, 50, { isStatic: true }),
        Bodies.rectangle(containerWidth / 2, containerHeight + 25, containerWidth, 50, { isStatic: true }),
        Bodies.rectangle(-25, containerHeight / 2, 50, containerHeight, { isStatic: true }),
        Bodies.rectangle(containerWidth + 25, containerHeight / 2, 50, containerHeight, { isStatic: true }),
    ];

    // Ajouter les limites au monde physique
    World.add(world, boundaries);

    // Ajuster la gravité selon la direction
    if (direction === 'up') {
        engine.gravity.y = -1;  
    } else if (direction === 'down') {
        engine.gravity.y = 1;   
    } else if (direction === 'left') {
        engine.gravity.y = 0;
        engine.gravity.x = -1;  
    } else if (direction === 'right') {
        engine.gravity.y = 0;
        engine.gravity.x = 1;   
    }

    // Créer un corps physique pour chaque élément HTML et l'ajouter au monde
    const bodies = elements.map((element) => {
        const elementWidth = element.offsetWidth;
        const elementHeight = element.offsetHeight;

        const x = element.offsetLeft + elementWidth / 2;  
        const y = element.offsetTop + elementHeight / 2;  

        const initialRotation = element.style.transform.match(/rotate\((-?\d+)deg\)/);
        const rotation = initialRotation ? parseInt(initialRotation[1], 10) : 0; 

        const body = Bodies.rectangle(x, y, elementWidth, elementHeight, {
            restitution: 0.8,
            friction: 0.5,
            angle: rotation * (Math.PI / 180) 
        });

        World.add(world, body);
        return { element, body };
    });

    // Ajouter les éléments statiques (solids)
    solids.forEach((element) => {
        const elementWidth = element.offsetWidth;
        const elementHeight = element.offsetHeight;

        const x = element.offsetLeft + elementWidth / 2;  
        const y = element.offsetTop + elementHeight / 2;  

        const initialRotation = element.style.transform.match(/rotate\((-?\d+)deg\)/);
        const rotation = initialRotation ? parseInt(initialRotation[1], 10) : 0;

        const body = Bodies.rectangle(x, y, elementWidth, elementHeight, {
            restitution: 0.8,
            friction: 0.5,
            angle: rotation * (Math.PI / 180),
            isStatic: true // Le rendre statique
        });

        World.add(world, body);
    });

    // Fonction qui met à jour les positions et les rotations des éléments HTML selon la simulation physique
    function updateCSSPositions() {
        bodies.forEach(({ element, body }) => {
            const x = body.position.x - element.offsetWidth / 2;  
            const y = body.position.y - element.offsetHeight / 2; 

            // Mettre à jour la position CSS des éléments en fonction des corps physiques
            element.style.left = `${x}px`;
            element.style.top = `${y}px`;

            // Appliquer la rotation CSS
            element.style.transform = `rotate(${body.angle * (180 / Math.PI)}deg)`;
        });
    }

    // Fonction pour vérifier si tous les corps sont au repos
    function allBodiesAtRest() {
        // Définir un seuil de vitesse en-dessous duquel un corps est considéré au repos
        const restThreshold = 0.1;

        // Vérifier la vitesse de chaque corps
        return bodies.every(({ body }) => body.speed < restThreshold);
    }

    // Fonction pour arrêter le runner lorsque tous les corps sont au repos
    function stopRunnerIfResting() {
        if (allBodiesAtRest()) {
            Runner.stop(runner); // Arrêter la simulation
        }
    }

    // Créer un "Runner" pour gérer la boucle
    const runner = Runner.create();

    // Lier l'événement 'afterUpdate' pour mettre à jour les positions CSS
    Events.on(engine, 'afterUpdate', () => {
        updateCSSPositions();  // Mise à jour des positions
        stopRunnerIfResting(); // Vérification si tout est au repos
    });

    // Démarrer le moteur avec Runner.run()
    Runner.run(runner, engine);
}
